import BasePage from 'basePage/BasePage';
import Users from 'pages/userPages/Users';
import SuperAdminView from 'pages/adminsView/SuperAdminView';
import Projects from 'pages/projects/Projects';
import RoofSections from 'pages/roofSection/RoofSections';
import Prices from 'pages/Prices/Prices';
import Calculator from 'pages/calculator/Calculator';
import AuthLayout from './AuthLayout';
import AreaAdminUser from 'pages/AreaAdminPages/AreaAdmins';
import Stores from 'pages/storePages/Stores';
import BracketStrengths from 'pages/bracketStrengths/BracketStrengths';
import BracketPrices from 'pages/BracketPricePages/BracketPrices';
import FenceCalculator from 'pages/fenceCalculator/FenceCalculator';
const AuthRoutes = {
  path: '/',
  element: <BasePage />,
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: 'AdminDashboard',
          element: <SuperAdminView />
        },
        {
          path: 'Stores',
          element: <Stores />
        },
        {
          path: 'Admins',
          element: <AreaAdminUser />
        },
        {
          path: 'Brackets',
          element: <BracketPrices />
        },
        {
          path: 'Strengths',
          element: <BracketStrengths />
        }
      ]
    },

    {
      path: 'StoreInfo/',
      element: <AuthLayout />,
      children: [
        {
          path: 'projects',
          element: <Projects />
        },
        {
          path: 'prices',
          element: <Prices />
        },
        {
          path: 'roof-section',
          element: <RoofSections />
        },
        {
          path: 'calculator',
          element: <Calculator />
        },
        {
          path: 'calculator-fence',
          element: <FenceCalculator />
        },
        {
          path: 'users',
          element: <Users />
        }
      ]
    }
  ]
};

export default AuthRoutes;
